import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useDocumentTitle from '../hooks/useDocumentTitle'
import {AUTH_DIALOG_WIDTH} from './AuthenticationDialog'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import EmailPasswordAuthForm from './EmailPasswordAuthForm'
import ForgotPasswordOneClick from './ForgotPasswordOneClick'
import InvitationCenteredCopy from './InvitationCenteredCopy'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'






const StyledDialog = styled(InviteDialog)({
  maxWidth: AUTH_DIALOG_WIDTH
})

const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const TeamInvitationEmailSignin = (props) => {
  const {invitationToken, verifiedInvitation: verifiedInvitationRef} = props
  const verifiedInvitation = useFragment(
    graphql`
      fragment TeamInvitationEmailSignin_verifiedInvitation on VerifiedInvitationPayload {
        meetingName
        user {
          preferredName
        }
        teamInvitation {
          email
        }
        teamName
      }
    `,
    verifiedInvitationRef
  )
  const {meetingName, user, teamInvitation, teamName} = verifiedInvitation
  useDocumentTitle(`Sign in | Team Invitation`, 'Sign in')
  if (!user || !teamInvitation) return null
  const {preferredName} = user
  const {email} = teamInvitation
  return (
    _jsxs(StyledDialog, { children: [
      _jsxs(DialogTitle, { children: ["Welcome back, "  , preferredName, "!"]})
      , _jsxs(DialogContent, { children: [
        _jsxs(InvitationDialogCopy, { children: ["Enter your password"

          , meetingName ? ` to join ${meetingName} for: ` : ' for immediate access to your team: '
          , _jsx(TeamName, { children: teamName})
        ]})
        , _jsxs(InvitationCenteredCopy, { children: [
          _jsx(EmailPasswordAuthForm, {
            email: email,
            isPrimary: true,
            isSignin: true,
            invitationToken: invitationToken,}
          )
          , _jsx(ForgotPasswordOneClick, { email: email,} )
        ]})
      ]})
    ]})
  )
}

export default TeamInvitationEmailSignin
